import { render, staticRenderFns } from "./CentroCostoList.vue?vue&type=template&id=038b826d&scoped=true&"
import script from "./CentroCostoList.vue?vue&type=script&lang=js&"
export * from "./CentroCostoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b826d",
  null
  
)

export default component.exports